import { useState } from 'react'
import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Nav from 'react-bootstrap/Nav'
import ImageLoader from '../components/ImageLoader'
import FormGroup from '../components/FormGroup'
import DropdownSelect from '../components/DropdownSelect'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { useRouter } from "next/router";
import PropertyCard from "../components/PropertyCard";
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import { listingPath } from '../libs/utils/seo';
import { Dropdown as Dropdown2 } from 'react-bootstrap'

import BgParallax from '../components/BgParallax'

// Links of the "Découvrez Facilykey au Maroc" cards (city / neighbourhood ids from /api/ads/localisation)
const LOCALISATIONS = [
  {
    img: '/images/localisations/usa.svg',
    title: 'Populaires',
    links: [
      ['/catalog?city=11', 'Marrakech'],
      ['/catalog?city=4', 'Casablanca'],
      ['/catalog?city=2', 'Benslimane'],
      ['/catalog?city=17', 'Rabat'],
    ]
  },
  {
    img: '/images/localisations/field.svg',
    title: 'Villes',
    links: [
      ['/catalog?city=23', 'Tanger'],
      ['/catalog?city=4', 'Casablanca'],
      ['/catalog?city=8', 'Fès'],
      ['/catalog?city=11', 'Marrakech'],
    ]
  },
  {
    img: '/images/localisations/city.svg',
    title: 'Quartiers',
    links: [
      ['/catalog?city=4&neighbourhood=223', 'Sidi Maarof'],
      ['/catalog?city=4&neighbourhood=165', 'Hay Hassani'],
      ['/catalog?city=30&neighbourhood=134', 'Bouskoura'],
      ['/catalog?city=4&neighbourhood=112', 'Almaz'],
    ]
  },
]

// Number of listings shown in "Notre sélection"
const RECENT_LIMIT = 12

const HomeAltPage = ({ cities = [], recentProperties = [] }) => {
  const { t } = useTranslation('common');

  const router = useRouter();
  const { pathname, asPath, query, locale } = router; // Get the current route and locale
  const isRTL = locale === 'ar';

  const [citySelected, setCitySelected] = useState('');
  const [typeTransaction, setTypeTransaction] = useState('Acheter');
  const [typeBienSelected, setTypeBienSelected] = useState('');

  // Helper to format number with spaces
  const formatPrice = (value) => {
    if (!value) return '';
    // Remove existing spaces and non-digits
    const rawValue = value.replace(/\D/g, '');
    return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  const handleMinPriceChange = (e) => {
    const value = e.target.value;
    // Allow digits and spaces
    if (/^[\d\s]*$/.test(value)) {
      setMinPrice(formatPrice(value));
    }
  };

  const handleMaxPriceChange = (e) => {
    const value = e.target.value;
    // Allow digits and spaces
    if (/^[\d\s]*$/.test(value)) {
      setMaxPrice(formatPrice(value));
    }
  };



  return (
    <RealEstatePageLayout
      pageTitle={t("Annonces Immobilières - Achat, Localisation, Estimation & Vente")}
      activeNav='Home'
      description={t("Annonces immobilières au Maroc : appartements, villas, terrains et locaux à vendre ou à louer à Casablanca, Marrakech, Rabat et Tanger. Estimation gratuite.")}
    >
      {/* Hero */}
      <Container fluid as='section' className='my-5 pt-5 pb-lg-4 px-xxl-4'>
        <BgParallax
          imgSrc='/images/header/casamarina-1920.webp'
          imgSrcSet='/images/header/casamarina-960.webp 960w, /images/header/casamarina-1920.webp 1920w'
          priority
          type='scroll-opacity' // scale, opacity, scroll-opacity, scale-opacity
          speed={0.2} // from -1.0 to 2.0
          overlay={30} // from 0 to 100 or 'gradient' to apply gradient overlay
          contentWrapper={{
            style: { maxWidth: '950px' }
          }}
          className='card align-items-center justify-content-center border-0 p-md-5 p-4 bg-secondary mt-n3'
          style={{ minHeight: '65vh', zIndex: 2 }}
        >
          <h1 style={{ fontSize: 34 }} className='fw-normal mb-5 pb-md-3 px-md-3 text-white text-center'>
            {t("Votre projet, notre passion : parce que chaque projet mérite une attention unique")}
          </h1>
          {/* Search property form group */}
          <Col xs={{ order: 3 }} lg={11} xl={12} className='position-relative zindex-2'>
            <FormGroup method={'GET'} action={locale === 'fr' ? '/catalog' : `/${locale}/catalog`} className='d-block'>
              <Row className='g-0 ms-sm-n2'>
                <Col md={10} className='d-sm-flex align-items-center'>
                  <input type="hidden" name={"category"} value={typeTransaction === t('Louer') ? 'location' : 'vendre'} />
                  <DropdownSelect
                    onSelect={(e) => setTypeTransaction(e)}
                    selected={t(typeTransaction)}
                    defaultValue={t('Acheter')}
                    icon='fi-home'
                    options={[
                      ['rent', t('Louer')],
                      ['sell', t('Acheter')],
                    ]}
                    variant='link ps-2 ps-sm-3'
                    className='w-sm-50 border-end-sm'
                  />
                  <input type="hidden" name={"city"} value={citySelected.id_city} />
                  <hr className='d-md-none mt-2 mr-3' />
                  <div className={'w-sm-50 border-end-sm px-2 px-sm-3'}>
                    <Dropdown value={citySelected}
                      onChange={(e) => setCitySelected(e.value)}
                      options={cities}
                      optionLabel="name"
                      placeholder={t("Ville")}
                      pt={{ input: { 'aria-label': t("Ville") }, select: { 'aria-label': t("Ville") } }}
                      filter
                      field={'name'}
                      className="w-full md:w-14rem"
                    />
                  </div>
                  <input type="hidden" name={"type_bien"} value={typeBienSelected} />
                  <hr className='d-sm-none my-2' />
                  <DropdownSelect
                    onSelect={(e) => setTypeBienSelected(e)}
                    selected={typeBienSelected}
                    defaultValue={t('Type de bien')}
                    icon='fi-list'
                    options={[
                      ['Appartement', t('Appartement')],
                      ['Maison', t('Maison')],
                      ['Villa', t('Villa')],
                      ['Local commercial', t('Local commercial')],
                      ['Terrain', t('Terrain')],
                      ['Immeuble', t('Immeuble')],
                      ['Bureau', t('Bureau')],
                      ['Studio', t('Studio')],
                      ['Ferme', t('Ferme')],
                      ['Parking', t('Parking')],
                    ]}
                    variant='link ps-2 ps-sm-3'
                    className='w-sm-50 border-end-md'
                  />
                  <hr className='d-md-none mt-2' />
                  <Dropdown2 className='ps-2' style={{ borderWidth: 0 }}>
                    <Dropdown2.Toggle variant='link ps-2 ps-sm-3'>
                      <i className='fi-search me-2' aria-label="Search Icon" title="Search"></i> {t("Budget")}
                    </Dropdown2.Toggle>

                    <Dropdown2.Menu style={{ width: '20rem' }}>
                      <div className='p-4'>
                        <div className='mb-3'>
                          <label htmlFor='minPrice' className='form-label'>
                            {t("Prix minimum")}
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='minPrice'
                            placeholder={t("Prix minimum")}
                            value={minPrice}
                            onChange={handleMinPriceChange}
                          // required
                          />
                        </div>
                        <div className='mb-3'>
                          <label htmlFor='maxPrice' className='form-label'>
                            {t("Prix maximum")}
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            id='maxPrice'
                            placeholder={t("Prix maximum")}
                            value={maxPrice}
                            onChange={handleMaxPriceChange}
                          // required
                          />
                        </div>
                      </div>
                    </Dropdown2.Menu>
                  </Dropdown2>


                  <hr className='d-md-none mt-2' />
                </Col>
                <Col className={`d-flex justify-content-end align-items-end align-self-end`}>
                  <Button type={'submit'} variant='primary btn-icon px-3 w-100 w-sm-auto flex-shrink-1' aria-label={t('Rechercher')}>
                    <i className='fi-search'></i>
                    <span className='d-sm-none d-inline-block ms-2'>{t('Rechercher')}</span>
                  </Button>
                </Col>
              </Row>
              <input type="hidden" name={"minPrice"} value={minPrice ? minPrice.replace(/\s/g, '') : ''} />
              <input type="hidden" name={"maxPrice"} value={maxPrice ? maxPrice.replace(/\s/g, '') : ''} />
            </FormGroup>
          </Col>
        </BgParallax>
      </Container>

      <Container as='section' className='mb-5 pb-md-4'>
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <h2 className='h3 mb-0'>{t("Notre sélection")}</h2>
          <Button as={Link} href='/catalog' variant='link fw-normal ms-sm-3 p-0'>
            {t('Voir tout')}
            <i className={`fi-arrow-long-${locale === 'ar' ? 'left' : 'right'} ms-2`}></i>
          </Button>
        </div>

        <Row xs={1} sm={2} xl={4} className='g-4 py-4'>
          {recentProperties.map((property, indx) => (
              <Col key={indx}>
                <PropertyCard
                  ribbon={property.ribbon}
                  href={listingPath(property.title, property.id)}
                  images={property.imagesTransformed}
                  title={property.title}
                  category={property.category}
                  thumbnail={property.img}
                  location={property.location}
                  price={property.price}
                  badges={property.badges}
                  footer={[
                    ['fi-bed', property.amenities[0]],
                    ['fi-bath', property.amenities[1]],
                    ['fi-parking', property.amenities[2]]
                  ]}
                  className='h-100 mx-2'
                />
              </Col>
            ))}
        </Row>

      </Container>

      {/* Steps (How it works) */}
      <Container as='section' className='mb-5 pb-2 pb-lg-4'>
        <Row className='gy-4 pb-2 pb-sm-4 align-items-center'>
          <Col xs={12} md={5} className={`${isRTL ? 'text-md-end' : 'text-md-start'} text-center`}>
            <div className='d-inline-block' style={{ borderRadius: '30px' }}>
              <ImageLoader src='/images/illustrations/sell_illustration.png' width={795} height={530} alt={t("Comment nous procédons")} className={'rounded-3'} />
            </div>
          </Col>
          <Col xs={12} md={7} lg={{ span: 6, offset: 1 }}>
            <h2 className='h2 mb-lg-5 mb-sm-4'>{t("Comment nous procédons")}</h2>
            <div className='steps steps-vertical'>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>1</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Estimation personnalisée offerte")}</h3>
                  <p className='mb-0'>{t("Notre agent de votre secteur se déplace pour réaliser gratuitement un avis de valeur, afin de définir le juste prix de votre bien.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>2</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Mise en valeur et diffusion")}</h3>
                  <p className='mb-0'>{t("Nos agents réalisent vos photos professionnelles et rédigent l’annonce pour mettre en avant les atouts de votre bien pour les diffuser sur les principaux portails immobiliers et de nombreux autres sites.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>3</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Gestion des visites")}</h3>
                  <p className='mb-0'>{t("Votre agent partenaire vérifie la solvabilité des acquéreurs, prend en charge les visites et vous adresse ses comptes rendus.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>4</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Un cadre sécurisé")}</h3>
                  <p className='mb-0'>{t("Nous vous accompagnons étape par étape jusqu’à la signature définitive. La signature du compromis et la remise des clés se font chez le notaire pour une transaction sécurisée.")}</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {/* Services (carousel on screens < 992px) */}
      <Container as='section' className='mb-5 mt-n3 mt-lg-0'>
        <Swiper
          modules={[Pagination]}
          pagination={{
            el: '#paginationServices',
            clickable: true
          }}
          spaceBetween={24}
          breakpoints={{
            0: { slidesPerView: 1 },
            500: { slidesPerView: 2 },
            768: { slidesPerView: 3 }
          }}
          className='py-3 mx-n2'
        >
          <SwiperSlide>
            <Card className='card-hover border-0 h-100 pb-2 pb-sm-3 px-sm-3 text-center mx-2'>
              <div className='d-flex justify-content-center my-3' >
                <ImageLoader src='/images/illustrations/buy_illustration.jpeg' width={1254} height={836} alt={t("Acheter un bien")} className={'rounded-3'} />
              </div>
              <Card.Body>
                <h2 className='h4 card-title' style={{ color: 'rgba(0,0,0,.7)' }}>{t("Acheter un bien")}</h2>
                <p className='card-text fs-sm'>{t("Consultez la liste de nos biens en ligne")}</p>
              </Card.Body>
              <Card.Footer className='pt-0 border-0'>
                <Button as={Link} href='/catalog' variant='outline-primary stretched-link'>{t("Trouver un bien")}</Button>
              </Card.Footer>
            </Card>
          </SwiperSlide>
          <SwiperSlide>
            <Card className='card-hover border-0 h-100 pb-2 pb-sm-3 px-sm-3 text-center mx-2'>
              <div className='d-flex justify-content-center my-3'>
                <ImageLoader src='/images/illustrations/sell_illustration2.jpg' width={1254} height={836} alt={t('Vendre votre bien')} className={'rounded-3'} />
              </div>
              <Card.Body>
                <h2 className='h4 card-title' style={{ color: 'rgba(0,0,0,.7)' }}>{t('Vendre votre bien')}</h2>
                <p className='card-text fs-sm'>{t("A l'aide de notre réseau d'agents de proximité")}</p>
              </Card.Body>
              <Card.Footer className='pt-0 border-0'>
                <Button as={Link} href='/contacts' variant='outline-primary stretched-link'>{t("Faire appel à un agent")}</Button>
              </Card.Footer>
            </Card>
          </SwiperSlide>
          <SwiperSlide>
            <Card className='card-hover border-0 h-100 pb-2 pb-sm-3 px-sm-3 text-center mx-2'>
              <div className='d-flex justify-content-center my-3'>
                <ImageLoader src='/images/illustrations/estimate_illustration.jpg' width={1254} height={836} alt={t("Estimer votre bien")} className={'rounded-3'} />
              </div>
              <Card.Body>
                <h2 className='h4 card-title' style={{ color: 'rgba(0,0,0,.7)' }}>{t("Estimer votre bien")}</h2>
                <p className='card-text fs-sm'>{t("Facile et rapide en seulement 2 minutes")}</p>
              </Card.Body>
              <Card.Footer className='pt-0 border-0'>
                <Button as={Link} href='/estimate-property' variant='outline-primary stretched-link'>{t("Estimer votre bien")}</Button>
              </Card.Footer>
            </Card>
          </SwiperSlide>
        </Swiper>

        {/* External pagination (bullets) */}
        <div id='paginationServices' className='swiper-pagination position-relative bottom-0 d-md-none mt-2'></div>
      </Container>










      {/* Property cost calculator */}
      <Container as='section' className='mb-5 pb-2 pb-lg-4'>
        <Row className='align-items-center g-4'>
          <Col md={6}>
            <div className={`d-flex justify-content-center ${isRTL ? 'justify-content-md-end' : 'justify-content-md-start'} mb-md-0 mb-4`}>
              <ImageLoader
                src='/images/illustrations/estimer_bloc.jpeg'
                width={1280}
                height={849}
                className={'rounded'}
                alt={t("Estimer votre bien avec Facilykey")}
              />
            </div>
          </Col>
          <Col md={5} xxl={5} className={`${isRTL ? 'text-md-end' : 'text-md-start'} text-center ${isRTL ? 'pe-4' : 'ps-4'}`}>
            <h2>{t("Estimer votre bien avec Facilykey")}</h2>
            <p className='pb-3 fs-lg'>{t("Rapide et simple, notre outil vous fournit une estimation précise de votre bien immobilier.")}</p>
            <Button size='lg' as={Link} href='/estimate-property'>
              <i className='fi-calculator me-2'></i>
              {t("Faire mon estimation")}
            </Button>
          </Col>
        </Row>
      </Container>


      {/* Localisations */}
      <Container as='section' className='mb-5 pb-lg-5 pb-4'>
        <div className='d-flex align-items-start justify-content-between mb-3 mb-md-4 pb-md-2'>
          <div className='d-flex flex-md-row flex-column align-items-center'>
            <h2 className='h3 mb-4 mb-md-0'>{t("Découvrez Facilykey au Maroc")}</h2>
            {/*<Nav as='ul' variant='tabs' defaultActiveKey='forRent' className='mb-0 ms-md-4 ms-n3 ps-lg-2'>*/}
            {/*<Nav.Item as='li'>*/}
            {/*  <Nav.Link eventKey='forRent'>Louer</Nav.Link>*/}
            {/*</Nav.Item>*/}
            {/*  <Nav.Item as='li'>*/}
            {/*    <Nav.Link eventKey='forSale'>Acheter</Nav.Link>*/}
            {/*  </Nav.Item>*/}
            {/*</Nav>*/}
          </div>
          <Button as={Link} href='/catalog?category=location' variant='link fw-normal ms-2 p-0'>
            {t('Voir tout')}
            <i className={`fi-arrow-long-${locale === 'ar' ? 'left' : 'right'} ms-2`}></i>
          </Button>
        </div>

        {/* Carousel on screens < 768px */}
        <Swiper
          modules={[Pagination]}
          pagination={{
            el: '#paginationLocalisations',
            clickable: true
          }}
          spaceBetween={8}
          breakpoints={{
            0: { slidesPerView: 1 },
            500: { slidesPerView: 2 },
            768: { slidesPerView: 3 }
          }}
          className='py-3 mx-n2'
        >
          {LOCALISATIONS.map((localisation, indx) => (
            <SwiperSlide key={indx} className='h-auto'>
              <Card className='card-hover border-0 shadow-sm h-100 p-2 mx-2'>
                <Card.Body className='px-4 pt-4 pb-2'>
                  <div className='d-flex mb-3'>
                    <ImageLoader
                      src={localisation.img}
                      width={80}
                      height={80}
                      alt=''
                      className='rounded-3'
                    />
                  </div>
                  <h3 className='h5 mb-1'>{t(localisation.title)}</h3>
                  <hr className='my-4' />
                  <Nav as='ul' className='flex-column mb-0'>
                    {localisation.links.map((link, indx) => (
                      <Nav.Item key={indx} as='li' className='mb-2 pb-1'>
                        <Nav.Link as={Link} href={link[0]} active={false} className='p-0 fw-normal'>{t(link[1])}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Card.Body>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* External pagination (bullets) buttons */}
        <div id='paginationLocalisations' className='swiper-pagination position-relative bottom-0 d-md-none py-2 mt-2'></div>
      </Container>

    </RealEstatePageLayout>
  )
}

export default HomeAltPage

// Pre-rendered per locale and refreshed every 5 minutes, so the listings are
// in the HTML Google receives and the API is not hit on every visit.
export async function getStaticProps() {
  const [recentResult, locationsResult] = await Promise.allSettled([
    axios.get(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/properties/recent`),
    axios.get(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/localisation`),
  ]);

  const recentProperties = recentResult.status === 'fulfilled' && Array.isArray(recentResult.value.data)
    ? recentResult.value.data.slice(0, RECENT_LIMIT).map((property) => ({
      // Only what the cards display (the API also sends descriptions, a second photo list, ...)
      id: property.id,
      title: property.title,
      category: property.category,
      price: property.price,
      location: property.location,
      img: property.img,
      imagesTransformed: property.imagesTransformed,
      amenities: property.amenities,
      ribbon: property.ribbon,
      badges: property.badges,
    }))
    : [];
  const cities = locationsResult.status === 'fulfilled'
    ? (locationsResult.value.data.cities || []).map(({ id_city, name }) => ({ id_city, name }))
    : [];

  return {
    props: { recentProperties, cities },
    revalidate: 300,
  };
}
